export enum RemoteConfigKey {
  UnderMaintenanceDev = 'survey_under_maintenance_dev',
  UnderMaintenanceStaging = 'survey_under_maintenance_staging',
  UnderMaintenanceProduction = 'survey_under_maintenance_production',
  DownTimeReasonDescription = 'survey_down_time_reason_description',
  DownTimeReasonTitle = 'survey_down_time_reason_title',
  ExpectedBackAt = 'survey_expected_back_at'
}
export interface RemoteConfigKeyConfiguration {
  key: RemoteConfigKey;
  type: 'boolean' | 'string' | 'number' | 'json';
  showInNonProductionEnvironments?: boolean;
}
export const UnderMaintenanceConfigDev: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.UnderMaintenanceDev,
  type: 'boolean',
  showInNonProductionEnvironments: false
};
export const DownTimeReasonDesciptionConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.DownTimeReasonDescription,
  type: 'string'
};
export const DownTimeReasonTitleConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.DownTimeReasonTitle,
  type: 'string'
};
export const ExpectedBackAtConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.ExpectedBackAt,
  type: 'string'
};
